import { render, staticRenderFns } from "./index.vue?vue&type=template&id=57a62572&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=57a62572&lang=css"
import style1 from "./index.vue?vue&type=style&index=1&id=57a62572&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57a62572",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("G:\\pinmingproject\\suppervision-manager-ui-huangshi\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('57a62572')) {
      api.createRecord('57a62572', component.options)
    } else {
      api.reload('57a62572', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=57a62572&scoped=true", function () {
      api.rerender('57a62572', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/imgUpload/index.vue"
export default component.exports